export const isInternalUser = (email?: string): boolean => {
  if (!email) return false;
  const lower = email.toLowerCase();
  return lower.endsWith('@climate.com') || lower.endsWith('@climatecorp.support');
};
